import React from "react";
import { Table } from "react-bootstrap";
import { v4 as uuidv4 } from "uuid";
import "./availableForDepositShift.css";
import { useState, useEffect } from "react";
import {
  IEmployee,
  ILanguageData,
  IPropsAvailableForDepositShiftComponent,
} from "./interface";

export default function AvailableForDepositShift(
  props: IPropsAvailableForDepositShiftComponent
) {
  const [languageData, setLanguageData] = useState<ILanguageData>({
    shiftId: "",
    shiftDate: "",
    shiftNo: "",
    employeeName: "",
    cash: "",
    note: "",
    totalCash: "",
    show: "",
    hide: "",
    save: "",
    loading: "",
    modalCheckButton: "",
    modalCheckQuestion: "",
    modalPostFailedButton: "",
    modalPostFailedQuestion: "",
  });

  let cashSum = 0;

  props.shift.employees.forEach((employee: any) => {
    cashSum += employee.amount;
  });

  const shiftIdStr = props.shift.shiftId.toString();
  const year = shiftIdStr.slice(0, 4);
  const mouth = shiftIdStr.slice(4, 6);
  const day = shiftIdStr.slice(6, 8);

  return (
    <div className={"component-custom-border"}>
      <div className={"table-custom-border"}>
        <table className={"table-custom-border"}>
          <thead className={"first-thead "}>
            <tr>
              <th className={"custom-th-td "}>Shift Id</th>

              <th className={"custom-th-td "}>Date</th>

              <th className={"custom-th-td "}>Shift No</th>
            </tr>

            <tr>
              <td className={"custom-th-td "}>{props.shift.shiftId}</td>
              <td className={"custom-th-td "}>
                {day}/{mouth}/{year}
              </td>
              <td className={"custom-th-td "}>{shiftIdStr.slice(-2)}</td>
            </tr>
          </thead>
        </table>
      </div>
      <div>
        <div className={"table-custom-border"}>
          <table className={"table-custom-border"}>
            <thead>
              <tr>
                <th className={"custom-th-td custom-th-td-top"}>
                  EmployeeName
                </th>
                <th className={"custom-th-td custom-th-td-top"}>Cash</th>
                <th className={"custom-th-td custom-th-td-top"}>Note</th>
              </tr>
            </thead>
            <tbody>
              {props.shift.employees.map(
                (employee: IEmployee, index: number) => {
                  return (
                    <tr key={employee.shiftCashEntityId}>
                      <td className={"custom-th-td "}>
                        {employee.employeeName}
                      </td>
                      <td className={"custom-th-td "}>
                        {employee.amount}&#8378;
                      </td>
                      <td className={"custom-th-td "}>{employee.note}</td>
                    </tr>
                  );
                }
              )}
            </tbody>
            <thead>
              <tr>
                <th className={"custom-th-td custom-th-td-top "}>Total Cash</th>
                <th className={"custom-th-td custom-th-td-top"}>
                  {cashSum}&#8378;
                </th>
                <th className={"custom-th-td custom-th-td-top"}></th>
              </tr>
            </thead>
          </table>
        </div>
      </div>
    </div>
  );
}
